import React from "react";
import "../../style/helper.css";

class Homepage extends React.Component {
    render() {
        return (
            <div className="page-main">
                <div className="page-content">
                    <div className="homepage">
                        Promotional content on this page
                    </div>
                </div>
            </div>
        )
    }
}

export default Homepage;